<div class="backlog-wrapper">
  <div class="details dis-flex flex-sb">
    <div class="left-side">
      <div class="content-title dis-flex">
        <p-avatar label="B" class="outcome-type m-r-10 p-avatar-square" />
        <h4 class="m-b-10">
          {{ backlogData?.value}}
        </h4>
      </div>
      <div class="transform m-t-6">
        <!-- <button class="btn black b2 dis-flex wd-120px" *ngIf="backlogData?.accountable == userData?.data?.user_id" (click)="clickTransformBacklog(backlogData?.backlog_id)">
          <ng-icon class="m-r-5" name="hugeExchange01" size="1.3em"/> Transform 123456
        </button> -->
        <button class="btn black b2 dis-flex wd-120px" *ngIf="backlogData?.accountable == userData?.data?.user_id" (click)="openWizard()">          
          <ng-icon class="m-r-5" name="hugeExchange01" size="1.3em"/> Transform
        </button>
      </div>
    </div>
    <div class="right-side dis-flex flex-col">
      <div class="created-by text-right">
        <p class="caption text-60 font-medium m-b-0">Created By</p>
        
              @if(backlogData?.created_by?.avatar){
                <p-avatar
                class="p-avatar-square"
                image="{{backlogData?.created_by?.avatar}}"
                ngbTooltip="{{backlogData?.created_by?.name}}"
              />
              } @else {
                <p-avatar
                class="p-avatar-square"
                  image="{{env.assetUrl}}/user_placeholder.jpg"
                  [ngbTooltip]="backlogData?.created_by?.name"
                />
              }
      </div>
    </div>
  </div>
</div>

<!-- <div class="quarterly-outcome-card"> -->
  <!-- <app-quarterly-outcome [quarterlyOutcomesLists]="backlogData?.quarterly" ></app-quarterly-outcome> -->
  <!-- <app-milestone></app-milestone> -->
<!-- </div> -->
